import React, { Component } from "react";

export default class Collaboration extends Component {
  render() {
    return (
      <section className="section-collaboration parallax">
        <div className="row">
          <div className="col-sm-12">
            <div className="text-box-bg-image">
              <h1>
                COLLABORATIVE INVOLVEMENT AT EVERY STEP OF THE WAY
              </h1>
            </div>
          </div>
        </div>
      </section>
    );
  }
}
